import { render, staticRenderFns } from "./error-ui.vue?vue&type=template&id=1e8b94cd&"
import script from "./error-ui.vue?vue&type=script&lang=js&"
export * from "./error-ui.vue?vue&type=script&lang=js&"
import style0 from "./error-ui.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "error-ui.vue"
export default component.exports